import { render } from "./OnePage.vue?vue&type=template&id=7cc71516"
import script from "./OnePage.vue?vue&type=script&lang=js"
export * from "./OnePage.vue?vue&type=script&lang=js"

import "./OnePage.vue?vue&type=style&index=0&id=7cc71516&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__